import { z } from 'zod';

import { Nullable } from '@clearverify/types';

import { GetPartnershipsWhere } from 'src/api';
import { COMPANY_SEARCH_CATEGORY_MAP } from 'src/constants/company';

export const prepareSearchFilterByCategories = (
  searchValue: Nullable<string>,
  searchCategory: Nullable<string>,
): GetPartnershipsWhere => {
  if (!searchValue) return {};
  if (!searchCategory) searchCategory = COMPANY_SEARCH_CATEGORY_MAP.displayName;

  if (searchCategory === COMPANY_SEARCH_CATEGORY_MAP.displayName) {
    return {
      displayName: searchValue,
    };
  }

  if (searchCategory === COMPANY_SEARCH_CATEGORY_MAP.staffEmail) {
    const { success, data: staffEmail } = z.email().trim().safeParse(searchValue);
    if (!success || !staffEmail) return {};

    return {
      contactEmail: staffEmail,
    };
  }

  return {};
};
